/**
 * Holds the "view as role" selection and shares it with the nav and route
 * guards. Wraps the authenticated shell so both the sidebar (which items to
 * show) and RequireRole (which pages to allow) read the same effective role.
 */

import { useMemo, useState } from "react";
import type { PropsWithChildren } from "react";
import { RolePreviewContext } from "./RolePreviewContext";

export function RolePreviewProvider({ children }: PropsWithChildren) {
  const [previewRole, setPreviewRole] = useState<string | null>(null);
  const value = useMemo(() => ({ previewRole, setPreviewRole }), [previewRole]);
  return <RolePreviewContext.Provider value={value}>{children}</RolePreviewContext.Provider>;
}
